import { render, staticRenderFns } from "./Show-Profile.vue?vue&type=template&id=1ba68494&scoped=true&"
import script from "./Show-Profile.vue?vue&type=script&lang=js&"
export * from "./Show-Profile.vue?vue&type=script&lang=js&"
import style0 from "./Show-Profile.vue?vue&type=style&index=0&id=1ba68494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba68494",
  null
  
)

export default component.exports